export default "__VITE_ASSET__BHbZY6Wg__"